import { FIELD_TYPES_BY_CODE } from "../field_types.js";
import _ from "lodash";
import WidgetCommonMixin from "./WidgetCommonMixin.js";

export default {
  mixins: [WidgetCommonMixin],
  data: function () {
    return {};
  },
  props: {
    field: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
    fields: { type: Array, default: () => [] },
    hideLabel: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    on_input_number: function (value) {
      if (value === "") {
        value = null;
      } else {
        value = Number(value);
      }
      this.on_input(value);
    },
    on_input: function (value) {
      this.emitFieldChange("FormWidgetMixin", value);
    },
  },
  computed: {
    is_visible() {
      // First, check workflow field controls
      if (this.workflow_field_controls && this.workflow_field_controls.visible !== undefined) {
        return this.workflow_field_controls.visible;
      }

      // Check if widget should be visible based on for_state property
      if (this.field && this.field.for_state) {
        // If for_state has a value, check if it's true in item.states
        if (this.item && this.item.states) {
          return this.item.states[this.field.for_state] === true;
        }
        // If no states in item, hide widgets with for_state set
        return false;
      }
      // If no for_state set, always show
      return true;
    },
    validator_func() {
      if (this.field) {
        const fieldType = FIELD_TYPES_BY_CODE[this.field.field_type];
        if (fieldType && fieldType.validator) {
          return fieldType.validator(this.field);
        }
      }
      return null;
    },
    fieldErrors() {
      if (this.validator_func) {
        return this.validator_func(this.item);
      }
      return null;
    },
    field_value() {
      if (this.field) {
        if (this.has_value) {
          // get the value from Item
          return this.item[this.field.code];
        }

        // There is no value so return the default value
        return this.default_value;
      }
      return null; // default
    },
    has_value() {
      // Is there a value for this field in the Item?
      if (this.field && this.item) {
        return this.field.code in this.item;
      }
      return false;
    },

    default_value() {
      // Return the Default value for this field.

      //TODO check field_types for a default..
      if (this.field) {
        if (this.field.default_option) {
          const field_type = FIELD_TYPES_BY_CODE[this.field.field_type];
          if (field_type && _.isFunction(field_type.default_function)) {
            return field_type.default_function(this.field.default_value);
          } else {
            return this.field.default_value;
          }
        }
      }

      return null;
    },
    tooltip() {
      if (this.field) {
        if (this.field.params.tooltip) {
          return this.field.params.tooltip;
        }
      }

      return null;
    },
  },
};
